import {
  NgbDateParserFormatter,
  NgbDateStruct,
  NgbCalendar,
  NgbDatepickerI18n,
  NgbCalendarBuddhist,
  NgbDate,
} from "@ng-bootstrap/ng-bootstrap";
import * as moment from "moment";
import { Component, Injectable } from "@angular/core";
import localeThai from "@angular/common/locales/th";
import {
  getLocaleDayNames,
  FormStyle,
  TranslationWidth,
  getLocaleMonthNames,
  formatDate,
  registerLocaleData,
} from "@angular/common";

@Injectable()
export class NgbDatepickerI18nBuddhist extends NgbDatepickerI18n {
  private _locale = "th";
  private _weekdaysShort: readonly string[];
  private _monthsShort: readonly string[];
  private _monthsFull: readonly string[];

  constructor() {
    super();

    registerLocaleData(localeThai);

    const weekdaysStartingOnSunday = getLocaleDayNames(
      this._locale,
      FormStyle.Standalone,
      TranslationWidth.Short
    );
    this._weekdaysShort = weekdaysStartingOnSunday.map(
      (day, index) => weekdaysStartingOnSunday[(index + 1) % 7]
    );

    this._monthsShort = getLocaleMonthNames(
      this._locale,
      FormStyle.Standalone,
      TranslationWidth.Abbreviated
    );
    this._monthsFull = getLocaleMonthNames(
      this._locale,
      FormStyle.Standalone,
      TranslationWidth.Wide
    );
  }

  getMonthShortName(month: number): string {
    return this._monthsShort[month - 1] || "";
  }

  getMonthFullName(month: number): string {
    return this._monthsFull[month - 1] || "";
  }

  getWeekdayLabel(weekday: number) {
    return this._weekdaysShort[weekday - 1] || "";
  }

  getDayAriaLabel(date: NgbDateStruct): string {
    const jsDate = new Date(date.year, date.month - 1, date.day);
    return formatDate(jsDate, "fullDate", this._locale);
  }

  getYearNumerals(year: number): string {
    return String(year);
  }

  getWeekdayShortName(weekday: number): string {
    return this._weekdaysShort[weekday - 1] || "";
  }
}

export class MomentDateFormatter extends NgbDateParserFormatter {
  readonly DT_FORMAT = "DD/MM/YYYY";

  parse(value: string): NgbDateStruct {
    if (value) {
      const mdt = moment(value.trim(), this.DT_FORMAT);
      return { day: mdt.day(), month: mdt.month() + 1, year: mdt.year() };
    }
    return null;
  }
  format(date: NgbDateStruct): string {
    if (!date) {
      return "";
    }
    const mdt = moment([date.year, date.month - 1, date.day]);
    return mdt.isValid() ? mdt.format(this.DT_FORMAT) : "";
  }
}

export function dateParse(date: string): NgbDate | null {
  try {
    const [day, month, year] = date?.split("/");
    return new NgbDate(Number(year), Number(month), Number(day));
  } catch (error) {
    return null;
  }
}
